import Polyglot from "node-polyglot";
import localeJA from "./ja";

const DEFAULT_LOCALE = "ja";

export default new Polyglot({
  locale: DEFAULT_LOCALE,
  phrases: Object.assign({}, localeJA),
});
